import { getReadonlyListItemId, getReadonlyListItemString } from '@interxfi/app-components/components/readonly-list/util';
import type { ReadonlyListItemRecord } from '@interxfi/design-system/components/list';
import type { ExcJpmamV1MoneyMarketTransaction } from '@interxfi/types';
import { getJpmamNetOrderDetailPath } from './net-order/jpmam-net-order-routing';

export function getJpmamMoneyMarketTransactionListItems(data: ExcJpmamV1MoneyMarketTransaction | undefined, prefix = '') {
  return {
    netOrderId: getReadonlyListItemId(`${prefix}netOrderId`, 'Net Order ID', data?.netOrderId, getJpmamNetOrderDetailPath(data?.netOrderId)),
    description: data?.description ? getReadonlyListItemString(`${prefix}description`, 'Description', data.description) : undefined,
  } as const satisfies ReadonlyListItemRecord;
}
